var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher-links" } },
    _vm._l(_vm.options, function (option) {
      return _c(
        "div",
        {
          key: option.key,
          class: { "is-disabled": _vm.isDisabled },
          attrs: { "data-launcher-option": option.key },
        },
        [
          _c(
            "div",
            { staticClass: "icon-wrapper" },
            [_c("or-icon", { attrs: { icon: option.icon } })],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "label" }, [
            _vm._v("\n      " + _vm._s(_vm.$t(option.label)) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "or-button",
            {
              attrs: { "data-button": "go-to", disabled: _vm.isDisabled },
              on: {
                click: function ($event) {
                  return _vm.onClick(option.key)
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("HITL.common.actions.open")) +
                  "\n      "
              ),
              _c("or-icon", { attrs: { icon: "arrow_forward" } }),
            ],
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }